import { Fragment, useState } from "react";
import { Section, Spinner } from "design-react-kit";

import SubNavigation from "../../components/Header/SubNavigation";
import AIFlowNotificationsTable from "../../components/Tables/AIFlowNotificationsTable";
import Footer from "../../components/Footer";

const FlowNotificationsAI = () => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Fragment>
      <SubNavigation display={false} page={"flowNotificationsAI"} />
      <Section>
        <AIFlowNotificationsTable
          columns={[
            {
              name: "Data di acquisizione",
              type: "date",
              sortable: true,
              value: "importDate",
            },
            {
              name: "Notifica",
              type: "string",
              sortable: true,
              value: "notificationName",
            },
            {
              name: "Tipologia",
              type: "string",
              sortable: true,
              value: "clientName",
            },
            {
              name: "",
              type: null,
              sortable: false,
              value: "",
            },
          ]}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
        />
        {isLoading && (
          <div
            style={{
              height: "150px",
              textAlign: "center",
              marginTop: "-100px",
            }}
          >
            <Spinner double active />
          </div>
        )}
      </Section>
      <Footer />
    </Fragment>
  );
};

export default FlowNotificationsAI;
